export const BookingStep = ({
    title,
    step,
    children,
}: {
    title: string
    step: string
    children: React.ReactNode
}) => (
    <section className="mx-auto w-full max-w-3xl px-6 py-12">
        <div className="mb-8 flex flex-col gap-1">
            <p className="text-xs font-bold uppercase tracking-widest text-primary">{step}</p>
            <h1 className="text-3xl font-bold text-brand-dark">{title}</h1>
        </div>
        {children}
    </section>
)
